import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { useMaterialUIController, addAlert } from "context";
import React from "react";
import { deleteRoleDO } from "utils/rolesUtils";

export const DeleteRoleDialog = ({ roleId, onDelete }) => {
  const [controller, dispatch] = useMaterialUIController();

  const handleConfirm = async () => {
    await deleteRoleDO( roleId);
    addAlert(dispatch, "Role deleted successfully");
    if (onDelete) onDelete();
  };

  return (
    <AloveDialog
      dialogType={DialogType.DeleteRole}
      dialogTitle="Delete Role"
      dialogBody="Are you sure you want to delete this role? This action cannot be undone."
      dialogConfirm="Delete"
      error
      handleConfirm={handleConfirm}
      width="400px"
    />
  );
}; 